module.exports = __webpack_public_path__ + "img/binoculars.5c1a86ae.png";